
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";

import ExpandIcon from "@/components/utils/ExpandIcon.vue";
import appApplyLeaveInstructions from "@/components/process/AppealProcess/pathwayInstructions/appApplyLeaveInstructions.vue";
import appLeaveRefusedFinalInstructions from "@/components/process/AppealProcess/pathwayInstructions/appLeaveRefusedFinalInstructions.vue";
import respApplyCrossAppealInstructions from "@/components/process/AppealProcess/pathwayInstructions/respApplyCrossAppealInstructions.vue";

import "@/store/modules/forms/form4";
const form4State = namespace("Form4");

import "@/store/modules/forms/form8";
const form8State = namespace("Form8");

import {GetInstructionFile} from '@/components/utils/GetInstructionFile';

@Component({
    components:{
        ExpandIcon,
        appApplyLeaveInstructions,
        appLeaveRefusedFinalInstructions,
        respApplyCrossAppealInstructions
    }
})
export default class ApplyLeaveAppRightToAppealPg extends Vue {

    @Prop({required: true})
    app!: boolean;

    @form4State.Action
    public UpdateCurrentNoticeOfApplicationId!: (newCurrentNoticeOfApplicationId: string) => void
    
    @form8State.Action
    public UpdateCurrentNoticeOfApplicationToVaryId!: (newCurrentNoticeOfApplicationToVaryId: string) => void

    showIntroInfo = true;  
    showNoaLeaveInfo = false;    
    showNoaLeaveStayInfo = false;
    showRespNoaLeaveInfo = false;    
    showRespNoaLeaveStayInfo = false;
    showDecisionOnLeaveInfo = false;
    showRespVaryOrderInfo = false;
    transcriptExtractBookHelpText = '<div>If a witness spoke at your original trial or hearing, and you mentioned this oral testimony in your Factum, you will need to complete a Transcript Extract Book.</div>';
    affidavit = false;

    mounted(){
        this.affidavit = false;
    }
    
    public showIntro(show: boolean){
        if (show) {
            this.showIntroInfo = true;
            this.$emit('adjustHeights', 0, this.app?"16rem":"9rem");
        } else {
            this.showIntroInfo = false;
            this.$emit('adjustHeights', 0, "0");
        }
    }

    public showNoaLeave(show: boolean){
        if (show) {
            this.showNoaLeaveInfo = true;
            this.$emit('adjustHeights', 1, "26rem");
        } else {
            this.showNoaLeaveInfo = false;
            this.$emit('adjustHeights', 1, "0");
        }
    }

    public showNoaLeaveStay(show: boolean){
        if (show) {
            this.showNoaLeaveStayInfo = true;
            this.$emit('adjustHeights', 2, "26rem");
        } else {
            this.showNoaLeaveStayInfo = false;
            this.$emit('adjustHeights', 2, "0");
        }
    }

    public showRespNoaLeave(show: boolean){
       
        if (show) {
            this.showRespNoaLeaveInfo = true;
            this.$emit('adjustHeights', 1, "27rem");
        } else {
            this.showRespNoaLeaveInfo = false;
            this.$emit('adjustHeights', 1, "0");
        }
    }

    public showRespNoaLeaveStay(show: boolean){
        if (show) {
            this.showRespNoaLeaveStayInfo = true;
            this.$emit('adjustHeights', 2, "27.5rem");
        } else {
            this.showRespNoaLeaveStayInfo = false;
            this.$emit('adjustHeights', 2, "0");
        }
    }

    public showDecisionOnLeave(show: boolean){
        if (show) {
            this.showDecisionOnLeaveInfo = true;
            this.$emit('adjustHeights', 3, this.app?"63rem":"12rem");
        } else {
            this.showDecisionOnLeaveInfo = false;
            this.$emit('adjustHeights', 3, "0");
        }
    }

    public showRespVaryOrder(show: boolean){
        if (show) {
            this.showRespVaryOrderInfo = true;
            this.$emit('adjustHeights', 4, "26rem");
        } else {
            this.showRespVaryOrderInfo = false;
            this.$emit('adjustHeights', 4, "0");
        }
    }

    public startNewForm8Document(){
        this.UpdateCurrentNoticeOfApplicationToVaryId(null);
        this.$router.push({name: "start-form8" })
    }

    public startNewForm4Document(){
        this.UpdateCurrentNoticeOfApplicationId(null);
        this.$router.push({name: "start-form4" });
    }

    public downloadInstructions(file_name: string){
        GetInstructionFile(file_name);
    }

    public navigateToDraftOrders() {       
        this.$router.push({name: "checklist-orders"})
    }
        

}
